<template >
  <v-card
    class="ma-md-5 ma-lg-10"
  >
    <v-breadcrumbs
    v-if="crumbs.length > 1 && !this.user.hasIosUser()"
      :items="crumbs.map((el, $index) => ({ $index, ...el, }))"
    >
      <template v-slot:item="{ item }" >
        <v-breadcrumbs-item
          :to="item.to"
          :disabled="item.disabled"
          :exact=true
        >
          <v-icon
            color="primary"
            v-if="item.$index === 0"
          >{{ item.text }} </v-icon>
          <template v-else>{{ item.text }}</template>
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <div class="d-flex flex-nowrap align-center">
      <template v-if="!category && !loading">
        <Form
          id="SearchBarCatalog"
          ref="defaultFormDataSearch"
          class="px-4"
          :data="{ properties: formFields }"
          :submitVisible="false"
        >
        </Form>

        <v-btn
          class="mt-3 mr-4"
          icon
          color="primary"
          @click="flags.favRequestsVisible = !flags.favRequestsVisible"
        >
          <v-icon>{{
            flags.favRequestsVisible
            ? 'mdi-bookmark' : 'mdi-bookmark-outline'
          }}</v-icon>
        </v-btn>
      </template>
    </div>

    <template v-if="loading">
      <template v-for="i in 5">
        <v-divider
          :key="`divider-${i}`"
        ></v-divider>

        <v-skeleton-loader
          :key="i"
          type="list-item-avatar"
          class="mx-auto my-4"
        ></v-skeleton-loader>
      </template>
    </template>

    <transition name="fade">
      <LinksList
        class="mt-4"
        v-if="!loading && !category && !flags.favRequestsVisible"
        :preffix="cleanPath($router.currentRoute.fullPath)"
        :items="listCatalogs"
      >
        <template #item-actions>
          <v-list-item-icon>
            <v-icon color="primary">mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </template>
      </LinksList>
    </transition>

    <transition name="fade">
      <LinksList
        v-if="!loading && category  && !flags.favRequestsVisible"
        :preffix="cleanPath($router.currentRoute.fullPath)"
        :items="elements[category].elements"
      >
        <template #item-actions="{ item }"
        v-if="!this.user.hasIosUser()">
          <v-list-item-action class="my-0" v-if="item.family.id===$getConst('elementFamily')">
            <v-btn width="48" height="48" icon @click.stop="$event => share($event, item)">
              <v-icon color="primary">mdi-share-variant</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action class="my-0" v-if="item.family.id===$getConst('elementFamily')">
            <v-btn width="48" height="48" icon @click.stop="$event => toggleFav($event, item)">
              <v-icon color="primary">
                  {{ isElementInBookmark(item)
                  ? 'mdi-bookmark' : 'mdi-bookmark-outline' }}
              </v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-icon v-if="item.family.id===$getConst('categoryFamily')">
            <v-icon color="primary">mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </template>
      </LinksList>
    </transition>

    <transition name="fade">
      <LinksList
        v-if="!loading && flags.favRequestsVisible"
        :preffix="cleanPath(
            ($router.options.base === '/' ? '' : $router.options.base)
          ).concat('/element/r')"
        :items="$store.state.bookmarks[bookmarkType].bookmark.items"
      >
        <template #item-actions="{ item }">
          <v-list-item-action class="my-0">
            <v-btn width="48" height="48" icon @click.stop="$event => share($event, item)">
              <v-icon color="primary">mdi-share-variant</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action class="my-0">
            <v-btn width="48" height="48" icon @click.stop="$event => toggleFav($event, item)">
              <v-icon color="primary">mdi-bookmark</v-icon>
            </v-btn>
          </v-list-item-action>
        </template>
      </LinksList>
    </transition>

    <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>

  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { STATUS } from '@/store/modules/catalog';
import { STATUS as BOOKMARKS_STATUS, BOOKMARK_TYPES } from '@/store/modules/bookmarks';
import { LinksList, ShareDialog, Form } from '@/components';
import FieldBuilderUtil from '@/components/form/field-builder-util';
import { NAMED_ROLES } from '@/store/modules/session';

const ticketTypeToBookmarkType = (type) => {
  switch (type) {
  default:
  case 'R': return BOOKMARK_TYPES.REQUESTS;
  case 'I': return BOOKMARK_TYPES.INCIDENTS;
  }
};
const TYPE_REQUEST = 'r';

export default {
  props: {
    ticketType: String,
    category: String,
    categoryParent: String,
    bookmarks: Boolean,
    searchtext: String,
  },
  data: ({ bookmarks }) => ({
    sharedItem: null,
    sharedDialogPosition: {},
    flags: {
      favRequestsVisible: bookmarks || false,
    },
    openDialog: false,
  }),
  components: {
    LinksList,
    ShareDialog,
    Form,
  },
  mounted() {
    if (this.user.hasIosUser()) {
      console.log('fetchCategoryElements IOS');
      this.category = this.listCatalogs[0].id;
      this.$router.push(`request/${this.listCatalogs[0].id}`);
    }
  },
  async created() {
    this.$root.$on('openFormGeneric', () => {
      this.openFormGeneric();
    });
    // const { catalogId, categoryId, elementId } = this;
    if (!this.listCatalogs.length) {
      if (!this.$store.getters['catalog/loaded'](this.ticketType, this.category)) {
        await this.$store.dispatch('catalog/loadCatalogCategories', {
          userId: this.user.id,
          locationId: this.user.location.id,
          type: this.ticketType,
        });
      }
    }

    if (this.category != null && !this.$store.getters['catalog/storedElements'](this.ticketType, this.category)) {
      await this.fetchCategoryElements(this.category);
    }

    const { bookmarkType } = this;
    const bookmarkTypeStatus = this.$store.getters['bookmarks/status'](bookmarkType);
    // if bookmarks[type] are not loaded yet we will request them
    if (![BOOKMARKS_STATUS.SUCCESS, BOOKMARKS_STATUS.LOADING].includes(bookmarkTypeStatus)) {
      this.$store.dispatch('bookmarks/get', { type: bookmarkType });
    }

    this.$root.$on('openFormGeneric', () => {
      this.openFormGeneric();
    });
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      user: ({ session }) => session.session.user,
      loading: ({ catalog: { status } }) => status === STATUS.LOADING,
      loaded: ({ catalog: { status } }) => [STATUS.SUCCESS, STATUS.ERROR].includes(status),
      categories: ({ catalog }) => catalog.categories,
      listCatalogs: ({ catalog }) => Object.keys(catalog.categories.R).map(
        (key) => catalog.categories.R[key].model,
      ),
      elements: ({ catalog }) => catalog.categories.R,
    }),
    crumbs() {
      const routePath = this.$route.path.endsWith('/') ? this.$route.path.slice(0, -1) : this.$route.path;
      const pathArray = routePath.split('/');
      pathArray.shift();
      const pathRepo = [
        [{ id: pathArray[0], name: 'mdi-keyboard-backspace' }], // first breadcrumb element forced to be translated
        this.listCatalogs,
        (this.elements[this.category] || []).elements];

      if (this.categoryParent) {
        pathArray.splice(2, 2);
      }

      const breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        breadcrumbArray.push({
          path,
          to: breadcrumbArray[idx - 1]
            ? `/${ breadcrumbArray[idx - 1].path }/${ path}`
            : `/${ path}`,
          text: ((pathRepo[idx] || []).find((el) => el.id === path) || {}).name || path,
        });
        return breadcrumbArray;
      }, []);

      if (this.categoryParent) {
        breadcrumbs.push({
          text: ((pathRepo[1] || []).find((el) => el.id === this.category) || {}).name,
        });
      }

      return breadcrumbs;
    },
    bookmarkType() {
      return ticketTypeToBookmarkType(this.ticketType);
    },
    isElementInBookmark() {
      return (element) => this.$store.getters['bookmarks/isInBookmark'](this.bookmarkType, element.id);
    },
    formFields() {
      return [
        FieldBuilderUtil
          .createField('searchCatalog').ofType('search')
          .withSequence(5)
          .withLabel(this.$t('navbar.requestSearch'))
          .withConfig({
            initialvalue: typeof this.searchtext === 'string' ? this.searchtext : undefined,
            component: 'catalogsearch',
            size: {
              sm: 6,
              md: 16,
              xl: 16,
              lg: 16,
            },
          })
          .withParams({
            mode: 'remote',
            target: 'namedquery',
            entity: 'catalogsByName',
            fields: 'id,name',
            'filters:repl': `${JSON.stringify({ type: 'R', text: '#value' })}`,
            lookandfeel: '#item.name',
          })
          .build(),
      ];
    },
    NAMED_ROLES: () => NAMED_ROLES,
  },
  watch: {
    $route(to) {
      if (typeof to.params.category === 'string'
        && this.elements[to.params.category].elements == null
        && !this.$store.getters['catalog/loaded'][this.ticketType]) {
        this.fetchCategoryElements(to.params.category);
      } else if (this.user.hasIosUser()) {
        console.log('fetchCategoryElements IOS');
        this.category = this.listCatalogs[0].id;
        if (this.$router.currentRoute.path === '/request') {
          this.$router.push(`${this.$router.currentRoute.path}/${this.listCatalogs[0].id}`);
        } else {
          this.$router.push(`${this.listCatalogs[0].id}`);
        }
      }
    },
  },

  methods: {
    fetchCategoryElements(category) {
      this.$store.dispatch('catalog/loadCategoryElements', {
        categoryId: category,
        type: this.ticketType,
      });
    },
    cleanPath(path) {
      return path.endsWith('/') ? path.slice(0, -1) : path;
    },
    share(evt, item) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: this.$t('components.share.mobile.requestCreation'),
          url: `${window.location.origin}${this.$router.options.base}element/r/${item.id}`,
          formName: item.name,
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}element/r/${item.id}`;
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t(`components.share.subjectBody.${this.ticketType}`)} ${item.name}`,
          url: fullShareUrl,
          formName: item.name,
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    async toggleFav(evt, item) {
      evt.preventDefault();

      const action = this.isElementInBookmark(item) ? 'bookmarks/remove' : 'bookmarks/add';
      try {
        await this.$store.dispatch(action, {
          type: ticketTypeToBookmarkType(this.ticketType),
          element: item,
        });
      } catch (ex) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.requestCreationView.bookmarksSyncError'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    openFormGeneric() {
      this.$router.push({
        name: 'formGeneric',
        path: `/element/r/${ process.env.VUE_APP_GENERAL_FORM }`,
        params: {
          isPermision: true,
          element: process.env.VUE_APP_GENERAL_FORM,
          type: TYPE_REQUEST,
        },
      });
    },
  },
};

</script>

<style lang="scss">
  .fade-enter-active {
    transition: opacity .2s;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-leave-active {
    display: none;
  }
</style>
